const swagger = {
    invalid_zod_type: 'Tipo de Zod inválido. Verifique a configuração do protetor de rota.',
    not_supported_zod_type_for_params: 'Tipo Zod não suportado para os parâmetros. Verifique a configuração do protetor de rota.',
};
export default swagger;
